<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Comisiones Asesor
                  </div> 
                </template> 
            
                <b-row style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03); 
                ;padding:15px;border: 1px ridge;" align-v="center">
                  <sw-searchs
                    :md="3"
                    :lg="3"
                    label='Asesor'
                    list='datos_asesor'
                    :filter="{campo: 'id_list_estado', value: 1}"
                    >
                  </sw-searchs> 
                  <b-col
                    :md="3"
                    :lg="3">
                    <b-form-group
                      label="Mes Aporte"
                    >
                      <c-multiselect
                        style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                        v-model="mes_periodo"                   
                        :options="lists.list_mes"
                        label="name"
                        track-by="name"
                        :allow-empty="false"
                        :clear-on-select="false"
                        :preselect-first="false"
                        :searchable="false"
                        placeholder="Seleccionar"
                        >
                      </c-multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col
                    :md="3"
                    :lg="3">
                    <b-form-group
                      label="Año Aporte"
                    >
                      <c-multiselect
                        style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                        v-model="ano_periodo"                   
                        :options="lists.list_ano"
                        label="name"
                        track-by="name"
                        :allow-empty="false"
                        :clear-on-select="false"
                        :preselect-first="false"
                        :searchable="false"
                        placeholder="Seleccionar"
                        >
                      </c-multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col 
                    :md="3"
                    :lg="3">
                    <b-button size="sm" style="float:right" :disabled="searchSw.value==null || searchSw.value==''" @click="getPdf">Imprimir</b-button>
                  </b-col>                  
                </b-row>  
            </b-card>           
      </b-col>      
    </b-row>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import Multiselect from 'vue-multiselect'
import SwSearchs from '@/components/forms/searchs.vue'

export default {
  name: "afiliacion_informes",
  components: { 
    SwSearchs,
    'c-multiselect': Multiselect,
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
